import styled, { css } from 'styled-components';

import { FadeInUpKeyframes } from 'DesignLibrary/keyframes';

interface ContainerProps {
  isFirstPageView: boolean;
}

export const Container = styled.div<ContainerProps>`
  max-width: 400px;
  min-width: 240px;
  flex-shrink: 0;
  opacity: 0;
  animation: ${FadeInUpKeyframes} 0.5s 2.8s forwards;

  ${({ isFirstPageView }) =>
    !isFirstPageView &&
    css`
      animation-delay: 1s;
    `}

  .link {
    color: var(--text-gray);
    font-size: 13px;
  }
  .medicare-banner-heading svg {
    background-color: var(--colors-blue-100);
    padding: 12px;
    width: 56px;
    height: 56px;
    border-radius: 8px;
    margin-right: 6px;
  }
  .medicare-banner-heading b {
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.35;
  }
`;
